import { Outlet } from 'react-router'
import { useMemo, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ContainerHeader, FullPageWrapper, type ITabItem, SpinnerLoader, Tabs } from 'shared/ui'
import { useChatbotLayoutContext } from 'pages/chatbot/context/chatbotLayoutContext'
import { ChatbotHelpGuideButton, ChatbotNewButton } from 'pages/chatbot/ui'
import { ChatbotListEmpty } from 'pages/chatbot/pages/chatbotList/ui/ChatbotListEmpty'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { ListLayoutContext, useListLayoutContext } from './context'
import { ListLayoutStore } from './store/ListLayoutStore'

const ListLayoutContent = observer(() => {
  const { loading, isEmpty } = useListLayoutContext()

  const chatbotLayoutStore = useChatbotLayoutContext()
  const { titleIconProps, handleToggleCollapse } = chatbotLayoutStore.pageLayoutStore

  const headActions = useMemo(() => {
    if (loading || isEmpty) return []

    return [
      {
        iconButtonComponent: <ChatbotHelpGuideButton />,
      },
      {
        iconButtonComponent: <ChatbotNewButton />,
      },
    ]
  }, [loading, isEmpty])

  const tabs: ITabItem[] = [
    {
      key: ChatbotPath.texting,
      name: 'Texting',
    },
    {
      key: ChatbotPath.calling,
      name: 'Calling',
      statusProps: {
        intent: 'warning',
        emphasis: 'high',
        title: 'Beta',
        size: 'label',
      },
    },
  ]

  return (
    <FullPageWrapper>
      {loading || isEmpty ? (
        <>
          {loading && <SpinnerLoader ariaLabel={'ChatbotList'} />}
          {!loading && isEmpty && <ChatbotListEmpty />}
        </>
      ) : (
        <>
          <ContainerHeader
            title={'Agents'}
            titleVariant={'heading-md'}
            titleIconProps={titleIconProps}
            titleIconAction={handleToggleCollapse}
            actions={headActions}
            actionsGap={8}
            paddingLeft={20}
          />
          <Tabs
            tabs={tabs}
            isNavigate
            isDefaultOverflow
            margin={'0 20px 12px 16px'}
            paddingInlineWrap={0}
          />
        </>
      )}
      <Outlet />
    </FullPageWrapper>
  )
})

export const ListLayout = () => {
  const [store] = useState(() => new ListLayoutStore())

  return (
    <ListLayoutContext.Provider value={store}>
      <ListLayoutContent />
    </ListLayoutContext.Provider>
  )
}
